import React, { useState, useEffect } from "react";
import { Form, useParams } from "react-router-dom";
import {
  Button,
  MenuItem,
  TextField,
  DialogActions,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  Select,
  IconButton,
  Icon,
  Tooltip,
  Snackbar,
  Chip,
  TableContainer,
  Paper,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";
import ApprovalIcon from "@mui/icons-material/Approval";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Link } from "react-router-dom";
import ListSubheader from "@mui/material/ListSubheader";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import DraftsIcon from "@mui/icons-material/Drafts";
import SendIcon from "@mui/icons-material/Send";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import StarBorder from "@mui/icons-material/StarBorder";

const DateTimeInput = (props) => {
  const doubleDigit = (number) => {
    if (String(number).length !== 2) {
      return "0" + String(number);
    }
    return number;
  };

  const formatTime = (dt_str) => {
    let date = new Date(dt_str + "Z");
    let res =
      doubleDigit(date.getUTCDate()) +
      "-" +
      doubleDigit(date.getUTCMonth() + 1) +
      "-" +
      date.getUTCFullYear() +
      " " +
      doubleDigit(date.getUTCHours()) +
      ":" +
      doubleDigit(date.getUTCMinutes()) +
      ":" +
      doubleDigit(date.getUTCSeconds());

    return res;
  };
  const [date, setDate] = useState(
    props.activeData[props.index]
      ? formatTime(props.activeData[props.index])
      : ""
  );

  useEffect(() => {
    if (props.activeData[props.index]) {
      let temp = props.activeData;
      temp[props.index] = formatTime(props.activeData[props.index]);
      props.setActiveData(temp);
    }
  }, []);

  const timeRegex = /^([0-1]{1}[0-9]{1}|2{1}[0-3]{1})(:[0-5]{1}[0-9]{1}){2}$/gm;

  function dateIsValid(date) {
    if (
      typeof date === "object" &&
      date !== null &&
      typeof date.getTime === "function" &&
      !isNaN(date)
    ) {
      return true;
    }

    return false;
  }

  return (
    <div className="date-time">
      <TextField
        label={props.obj.name}
        key={props.obj.id}
        fullWidth
        value={date}
        error={props.activeDataError[props.index]}
        helperText={
          props.activeDataError[props.index]
            ? "Enter  valid date in DD-MM-YYYY HH:MI:SS"
            : ""
        }
        onChange={(e) => {
          setDate(e.target.value);
          let temp = props.activeData;
          temp[props.index] = e.target.value;
          props.setActiveData(temp);
        }}
        placeholder="DD-MM-YYYY HH:MI:SS"
      />
    </div>
  );
};

const DBTextInput = (props) => {
  const [text, setText] = useState(props.activeData[props.index]);
  return (
    <TextField
      label={props.obj.name}
      key={props.obj.id}
      fullWidth
      value={text}
      error={props.activeDataError[props.index]}
      helperText={props.activeDataError[props.index] ? "Enter a value" : ""}
      onChange={(e) => {
        setText(e.target.value);
        let temp = props.activeData;
        temp[props.index] = e.target.value;
        props.setActiveData(temp);
      }}
    />
  );
};

const DBNumberInput = (props) => {
  const [number, setNumber] = useState(props.activeData[props.index]);

  return (
    <TextField
      label={props.obj.name}
      key={props.obj.id}
      type="number"
      value={number}
      error={props.activeDataError[props.index]}
      helperText={props.activeDataError[props.index] ? "Enter a value" : ""}
      onChange={(e) => {
        setNumber(e.target.value);
        let temp = props.activeData;
        temp[props.index] = e.target.value;
        props.setActiveData(temp);
      }}
    />
  );
};

const DBCheckbox = (props) => {
  const [check, setCheck] = useState(Boolean(props.activeData[props.index]));

  return (
    <FormGroup key={props.obj.id}>
      <FormControlLabel
        control={
          <Checkbox
            checked={check}
            onChange={(e) => {
              setCheck(e.target.checked);
              let temp = props.activeData;
              temp[props.index] = e.target.checked;
              props.setActiveData(temp);
            }}
          />
        }
        label={props.obj.name}
      />
    </FormGroup>
  );
};

const DBForeignKey = (props) => {
  const [id, setId] = useState(props.activeData[props.index]);

  return (
    <TextField
      label={props.obj.name + " ID"}
      key={props.obj.id}
      value={id}
      error={props.activeDataError[props.index]}
      helperText={props.activeDataError[props.index] ? "Enter a value" : ""}
      onChange={(e) => {
        setId(e.target.value);
        let temp = props.activeData;
        temp[props.index] = e.target.value;
        props.setActiveData(temp);
      }}
    />
  );
};

const DataTable = (props) => {
  const [selectAll, setSelectAll] = useState(false);
  const [trig, setTrig] = useState(false);
  const [indeterminant, setIndeterminant] = useState(false);

  useEffect(() => {
    setSelectAll(false);
    setIndeterminant(false);
  }, [props.data]);
  const doubleDigit = (number) => {
    if (String(number).length !== 2) {
      return "0" + String(number);
    }
    return number;
  };

  const formatTime = (dt_str) => {
    let date = new Date(dt_str + "Z");
    let res =
      doubleDigit(date.getUTCDate()) +
      "-" +
      doubleDigit(date.getUTCMonth() + 1) +
      "-" +
      date.getUTCFullYear() +
      " " +
      doubleDigit(date.getUTCHours()) +
      ":" +
      doubleDigit(date.getUTCMinutes()) +
      ":" +
      doubleDigit(date.getUTCSeconds());

    return res;
  };

  return (
    <TableContainer>
      <Table sx={{ minWidth: 650 }}>
        <TableHead>
          <TableRow>
            <TableCell padding="checkbox" className="table-head">
              <Checkbox
                color="primary"
                checked={selectAll}
                onClick={(e) => {
                  props.setSelectedRow(
                    new Array(props.data.length).fill(e.target.checked)
                  );
                  setSelectAll(!selectAll);
                  setTrig(!trig);
                }}
              />
            </TableCell>
            {props.dbTableFields.map((obj, index) => {
              return (
                <TableCell align="left" className="table-head" key={obj.id}>
                  {obj.name}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {props.data.map((row, index) => (
            <TableRow
              key={row[0]}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
              }}
            >
              <TableCell padding="checkbox" className="table-head">
                <Checkbox
                  checked={props.selectedRow[index]}
                  onChange={(e) => {
                    let temp = props.selectedRow;
                    temp[index] = e.target.checked;
                    props.setSelectedRow(temp);

                    setSelectAll(
                      temp.every((el) => {
                        if (el === true) return true;
                      })
                    );
                    setTrig(!trig);
                  }}
                />
              </TableCell>
              {row.map((obj, index) => {
                if (props.dbTableFields[index].field_type === "2") {
                  return (
                    <TableCell
                      align="left"
                      key={index}
                      className="table-cell"
                      onClick={() => {
                        props.setEditData(true);
                        props.setActiveData(row);
                        props.setDataDialog(true);
                      }}
                    >
                      {obj === 1 ? "True" : "False"}
                    </TableCell>
                  );
                } else if (props.dbTableFields[index].field_type === "3") {
                  return (
                    <TableCell
                      align="left"
                      key={index}
                      className="table-cell"
                      onClick={() => {
                        props.setEditData(true);
                        props.setActiveData(row);
                        props.setDataDialog(true);
                      }}
                    >
                      {formatTime(obj)}
                    </TableCell>
                  );
                } else {
                  return (
                    <TableCell
                      align="left"
                      key={index}
                      className="table-cell"
                      onClick={() => {
                        props.setEditData(true);
                        props.setActiveData(row);
                        props.setDataDialog(true);
                      }}
                    >
                      {obj}
                    </TableCell>
                  );
                }
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export const DashboardPage = (props) => {
  let { projectId } = useParams();
  const [proName, setProName] = useState("");
  const [activeTable, setActiveTable] = useState(null);
  const [open, setOpen] = React.useState(true);
  const [tables, setTables] = useState([]);
  const [data, setData] = useState([]);

  const [dbTableFields, setDbTableFields] = useState([]);

  const [dataDialog, setDataDialog] = useState(false);

  const [activeData, setActiveData] = useState([]);
  const [activeDataError, setActiveDataError] = useState([]);
  const [activeDataMessage, setActiveDataMessage] = useState([]);

  const [selectedRow, setSelectedRow] = useState([]);

  const [editData, setEditData] = useState(false);
  const [trig, setTrig] = useState(false);

  const [tableName, setTableName] = useState("");
  const [tableEditable, setTableEditable] = useState(true);

  const [userUsername, setUserUsername] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [userPasswordConfirm, setUserPasswordConfirm] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userName, setUserName] = useState("");

  const [userUsernameError, setUserUsernameError] = useState("");
  const [userPasswordError, setUserPasswordError] = useState("");
  const [userEmailError, setUserEmailError] = useState("");
  const [userNameError, setUserNameError] = useState("");

  const [userUsernameMessage, setUserUsernameMessage] = useState("");
  const [userPasswordMessage, setUserPasswordMessage] = useState("");
  const [userEmailMessage, setUserEmailMessage] = useState("");
  const [userNameMessage, setUserNameMessage] = useState("");

  const [passwordChange, setPasswordChange] = useState(false);

  const [loader, setLoader] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  const timeRegex = /^([0-1]{1}[0-9]{1}|2{1}[0-3]{1})(:[0-5]{1}[0-9]{1}){2}$/gm;

  function dateIsValid(date) {
    if (
      typeof date === "object" &&
      date !== null &&
      typeof date.getTime === "function" &&
      !isNaN(date)
    ) {
      return true;
    }

    return false;
  }

  useEffect(() => {
    setLoader(true);
    axios
      .get(`https://api.fabloq.com/user/dashboard/details/${projectId}`, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
      .then((res) => {
        setTables(res.data.tables);
        setProName(res.data.name);
        setLoader(false);
      });
  }, []);

  const handleTableSelect = (id) => {
    setActiveTable(id);
    setLoader(true);
    axios
      .get(`https://api.fabloq.com/user/dashboard/database/table/${id}`, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
      .then((res) => {
        setDbTableFields(res.data.fields);
        setTableName(res.data.name);
        setTableEditable(res.data.editable);
        setData(res.data.data);
        let temp_selected = new Array(res.data.data.length).fill(false);
        setSelectedRow(temp_selected);
        setActiveDataError(new Array(res.data.fields.length).fill(false));
        setLoader(false);
      });
  };

  const handleSubmitNewData = () => {
    let temp_arr = activeDataError;
    for (let i = 0; i < dbTableFields.length; i++) {
      if (dbTableFields[i].field_type === "2" || i === 0) {
        continue;
      } else if (
        dbTableFields[i].field_type === "3" &&
        Boolean(activeData[i])
      ) {
        let date;
        function dateIsValid(date) {
          if (
            typeof date === "object" &&
            date !== null &&
            typeof date.getTime === "function" &&
            !isNaN(date)
          ) {
            return true;
          }

          return false;
        }
        if (activeData[i].length !== 19) {
          temp_arr[i] = true;
          setTrig(!trig);
          return;
        } else {
          temp_arr[i] = false;
        }
        let day = Number(activeData[i].slice(0, 2));
        let month = Number(activeData[i].slice(3, 5));
        let year = Number(activeData[i].slice(6, 10));
        let hour = Number(activeData[i].slice(11, 13));
        let minute = Number(activeData[i].slice(14, 16));
        let second = Number(activeData[i].slice(17, 19));
        date = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
        if (!dateIsValid(date)) {
          temp_arr[i] = true;
          setTrig(!trig);
          return;
        } else {
          temp_arr[i] = false;
          activeData[i] = date.toISOString().replace("Z", "");
        }
      } else if (!Boolean(activeData[i])) {
        temp_arr[i] = true;
      } else {
        temp_arr[i] = false;
      }
    }
    if (
      !temp_arr.every((el) => {
        if (el === false) return true;
      })
    ) {
      setTrig(!trig);
      return;
    }
    setLoader(true);
    let data = new FormData();
    data.append("table", activeTable);
    data.append("data", JSON.stringify(activeData));

    axios
      .post("https://api.fabloq.com/user/dashboard/database/table/", data, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
      .then((res) => {
        handleTableSelect(activeTable);
        setDataDialog(false);
        setEditData(false);
        setActiveData([]);
        setLoader(false);
      });
  };

  const handleSubmitEditData = () => {
    let temp_arr = activeDataError;
    for (let i = 0; i < dbTableFields.length; i++) {
      if (dbTableFields[i].field_type === "2" || i === 0) {
        continue;
      } else if (
        dbTableFields[i].field_type === "3" &&
        Boolean(activeData[i])
      ) {
        let date;
        function dateIsValid(date) {
          if (
            typeof date === "object" &&
            date !== null &&
            typeof date.getTime === "function" &&
            !isNaN(date)
          ) {
            return true;
          }

          return false;
        }
        if (activeData[i].length !== 19) {
          temp_arr[i] = true;
          setTrig(!trig);
          return;
        } else {
          temp_arr[i] = false;
        }
        let day = Number(activeData[i].slice(0, 2));
        let month = Number(activeData[i].slice(3, 5));
        let year = Number(activeData[i].slice(6, 10));
        let hour = Number(activeData[i].slice(11, 13));
        let minute = Number(activeData[i].slice(14, 16));
        let second = Number(activeData[i].slice(17, 19));
        date = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
        if (!dateIsValid(date)) {
          temp_arr[i] = true;
          setTrig(!trig);
          return;
        } else {
          temp_arr[i] = false;
          activeData[i] = date.toISOString().replace("Z", "");
        }
      } else if (!Boolean(activeData[i])) {
        temp_arr[i] = true;
      } else {
        temp_arr[i] = false;
      }
    }
    if (
      !temp_arr.every((el) => {
        if (el === false) return true;
      })
    ) {
      setTrig(!trig);
      return;
    }
    setLoader(true);
    let data = new FormData();
    data.append("table", activeTable);
    data.append("data", JSON.stringify(activeData));

    axios
      .put("https://api.fabloq.com/user/dashboard/database/table/", data, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
      .then((res) => {
        handleTableSelect(activeTable);
        setDataDialog(false);
        setEditData(false);
        setActiveData([]);
        setLoader(false);
      });
  };

  const handleDeleteEditData = (indexes) => {
    let data = new FormData();
    let rows = indexes.map((obj, index) => {
      return obj;
    });
    data.append("rows", JSON.stringify(rows));
    data.append("table", activeTable);
    setLoader(true);
    axios
      .delete("https://api.fabloq.com/user/dashboard/database/table/", {
        headers: { Authorization: localStorage.getItem("token") },
        data: data,
      })
      .then((res) => {
        handleTableSelect(activeTable);
        setLoader(false);
      });
  };

  const handleSelectData = (row) => {
    if (!tableEditable && tableName === "user") {
      clearUser();
      setUserUsername(row[1]);
      setUserEmail(row[2]);
      setUserName(row[3]);
      setPasswordChange(false);
      setActiveData(row);
    } else {
      setActiveData(row);
    }
  };

  const email_regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

  const handleNewUser = () => {
    setUserUsernameError(false);
    setUserUsernameMessage(false);
    setUserEmailMessage(false);
    setUserEmailError(false);
    if (
      (!Boolean(userUsername) && !Boolean(userEmail)) ||
      (Boolean(userEmail) && !email_regex.test(userEmail)) ||
      !Boolean(userPassword) ||
      !Boolean(userPasswordConfirm)
    ) {
      if (!Boolean(userUsername) && !Boolean(userEmail)) {
        setUserUsernameError(true);
        setUserUsernameMessage("Please enter an username or email.");
      }
      if (Boolean(userEmail) && !email_regex.test(userEmail)) {
        setUserEmailMessage("Please enter valid email.");
        setUserEmailError(true);
      }
      if (!Boolean(userPassword) || !Boolean(userPasswordConfirm)) {
        setUserPasswordError(true);
        setUserPasswordMessage("Please enter a password.");
      }
      if (userEmailError || userUsernameError || userPasswordError) {
        return;
      }
    } else {
      setLoader(true);
      let data = new FormData();
      data.append("username", userUsername);
      data.append("name", userName);
      data.append("password", userPassword);
      data.append("email", userEmail);
      data.append("table", activeTable);

      axios
        .post("https://api.fabloq.com/user/dashboard/database/user/", data, {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        })
        .then((res) => {
          setLoader(false);
          if (res.data.status === "error") {
            if (res.data.type === "username exists") {
              setUserUsernameError(true);
              setUserUsernameMessage("Username already exists.");
            }
            if (res.data.type === "email exists") {
              setUserEmailError(true);
              setUserEmailMessage("Email already exists.");
            }
            if (res.data.type === "username invalid") {
              setUserUsernameError(true);
              setUserUsernameMessage(res.data.message);
            }
          } else {
            handleTableSelect(activeTable);
            setDataDialog(false);
            setEditData(false);
            setActiveData([]);
          }
        });
    }
  };

  const handleEditUser = () => {
    setUserUsernameError(false);
    setUserUsernameMessage(false);
    setUserEmailMessage(false);
    setUserEmailError(false);
    if (
      !Boolean(userUsername) ||
      !email_regex.test(userEmail) ||
      (passwordChange &&
        (!Boolean(userPassword) || !Boolean(userPasswordConfirm)))
    ) {
      if (!Boolean(userUsername) && !Boolean(userEmail)) {
        setUserUsernameError(true);
        setUserUsernameMessage("Please enter an username or email.");
      }
      if (Boolean(userEmail) && !email_regex.test(userEmail)) {
        setUserEmailMessage("Please enter valid email.");
        setUserEmailError(true);
      }
      if (
        passwordChange &&
        (!Boolean(userPassword) || !Boolean(userPasswordConfirm))
      ) {
        setUserPasswordError(true);
        setUserPasswordMessage("Please enter a password.");
      }
      if (userEmailError || userUsernameError || userPasswordError) {
        return;
      }
    } else {
      setLoader(true);
      let data = new FormData();
      data.append("username", userUsername);
      data.append("name", userName);
      data.append("password", userPassword);
      data.append("email", userEmail);
      data.append("table", activeTable);
      data.append("id", activeData[0]);

      axios
        .put("https://api.fabloq.com/user/dashboard/database/user/", data, {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        })
        .then((res) => {
          setLoader(false);
          if (res.data.status === "error") {
            if (res.data.type === "username exists") {
              setUserUsernameError(true);
              setUserUsernameMessage("Username already exists.");
            }
            if (res.data.type === "email exists") {
              setUserEmailError(true);
              setUserEmailMessage("Email already exists.");
            }
            if (res.data.type === "username invalid") {
              setUserUsernameError(true);
              setUserUsernameMessage(res.data.message);
            }
          } else {
            handleTableSelect(activeTable);
            setDataDialog(false);
            setEditData(false);
            setActiveData([]);
          }
        });
    }
  };

  const clearUser = () => {
    setUserEmail("");
    setUserName("");
    setUserUsername("");
    setUserPassword("");
    setUserPasswordConfirm("");
    setUserEmailError(false);
    setUserNameError(false);
    setUserPasswordError(false);
    setUserUsernameError(false);
    setUserEmailMessage("");
    setUserUsernameMessage("");
    setUserNameMessage("");
    setUserPasswordMessage("");
  };

  return (
    <div className="work-page">
      <Backdrop
        open={loader}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <CircularProgress color="primary" />
      </Backdrop>
      <Dialog
        open={dataDialog}
        onClose={() => {
          setDataDialog(false);
          setEditData(false);
          setActiveData([]);
        }}
      >
        <DialogTitle>{editData ? "Edit data" : "Add new data"}</DialogTitle>
        {!tableEditable && tableName === "user" ? (
          <DialogContent className="new-data-content">
            <TextField
              label="Username"
              value={userUsername}
              onChange={(e) => setUserUsername(e.target.value)}
              error={userUsernameError}
              helperText={userUsernameMessage}
            />
            <TextField
              label="Email"
              value={userEmail}
              onChange={(e) => setUserEmail(e.target.value)}
              error={userEmailError}
              helperText={userEmailMessage}
            />
            <TextField
              label="Name"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
              error={userNameError}
              helperText={userNameMessage}
            />
            {editData && !passwordChange ? (
              <a
                href="#"
                className="password-change"
                onClick={(e) => {
                  e.preventDefault();
                  setPasswordChange(true);
                }}
              >
                Change Password
              </a>
            ) : (
              <>
                <TextField
                  label="Password"
                  value={userPassword}
                  onChange={(e) => {
                    setUserPassword(e.target.value);
                    if (
                      Boolean(userPasswordConfirm) &&
                      userPasswordConfirm !== e.target.value
                    ) {
                      setUserPasswordError(true);
                      setUserPasswordMessage("Passswords do not match.");
                    } else {
                      setUserPasswordError(false);
                      setUserPasswordMessage("");
                    }
                  }}
                />
                <TextField
                  label="Confirm Password"
                  value={userPasswordConfirm}
                  onChange={(e) => {
                    setUserPasswordConfirm(e.target.value);
                    if (userPassword !== e.target.value) {
                      setUserPasswordError(true);
                      setUserPasswordMessage("Passwords do not match.");
                    } else {
                      setUserPasswordError(false);
                      setUserPasswordMessage("");
                    }
                  }}
                  error={userPasswordError}
                  helperText={userPasswordMessage}
                />
              </>
            )}
          </DialogContent>
        ) : (
          <DialogContent className="new-data-content">
            {dbTableFields.map((obj, index) => {
              if (obj.field_type === "0") {
                return (
                  <DBTextInput
                    obj={obj}
                    index={index}
                    activeData={activeData}
                    setActiveData={setActiveData}
                    activeDataError={activeDataError}
                    setActiveDataError={setActiveDataError}
                  />
                );
              } else if (obj.field_type === "1") {
                return (
                  <DBNumberInput
                    activeData={activeData}
                    setActiveData={setActiveData}
                    index={index}
                    obj={obj}
                    activeDataError={activeDataError}
                    setActiveDataError={setActiveDataError}
                  />
                );
              } else if (obj.field_type === "2") {
                return (
                  <DBCheckbox
                    activeData={activeData}
                    setActiveData={setActiveData}
                    index={index}
                    obj={obj}
                    activeDataError={activeDataError}
                    setActiveDataError={setActiveDataError}
                  />
                );
              } else if (obj.field_type === "4") {
                return (
                  <DBForeignKey
                    activeData={activeData}
                    setActiveData={setActiveData}
                    index={index}
                    obj={obj}
                    activeDataError={activeDataError}
                    setActiveDataError={setActiveDataError}
                  />
                );
              } else if (obj.field_type === "3") {
                return (
                  <DateTimeInput
                    obj={obj}
                    index={index}
                    activeData={activeData}
                    setActiveData={setActiveData}
                    activeDataError={activeDataError}
                    setActiveDataError={setActiveDataError}
                  />
                );
              }
            })}
          </DialogContent>
        )}

        <DialogActions>
          <Button
            onClick={() => {
              if (tableName === "user" && !tableEditable) {
                if (!editData) handleNewUser();
                else handleEditUser();
              } else if (editData) handleSubmitEditData();
              else handleSubmitNewData();
            }}
          >
            {editData ? "Save" : "Create"}
          </Button>
          {editData ? (
            <Button
              onClick={() => {
                handleDeleteEditData([activeData]);
                setDataDialog(false);
                setEditData(false);
                setActiveData([]);
              }}
            >
              Delete
            </Button>
          ) : (
            ""
          )}
          <Button
            onClick={() => {
              setDataDialog(false);
              setEditData(false);
              setActiveData([]);
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
      <div className="topbar">
        <div className="topbar-logo">
          <Link to={"/"}>
            <div class="surface">
              <p class="f-letter">F</p>
              <div class="logo-block"></div>
            </div>
          </Link>
        </div>
        <div className="topbar-tool">
          <Link to={"/workspace/" + projectId}>Workspace</Link>
        </div>
        <div className="topbar-tool">
          <Link to={"/database/" + projectId}>Database</Link>
        </div>
        <div className="topbar-tool">
          <Link to={"/dashboard/" + projectId}>Dashboard</Link>
        </div>
      </div>
      <div className="work-page-content">
        <div className="work-page-sidebar">
          <div className="work-page-sidebar-project">
            <p className="work-page-sidebar-label">Project Name</p>
            <p className="work-page-sidebar-project-name">{proName}</p>
          </div>
          <List sx={{ color: "#fff", padding: 2 }} component="nav">
            <ListItemButton onClick={handleClick}>
              <ListItemText primary="Edit Database" />
              {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {tables.map((obj, index) => {
                  return (
                    <ListItemButton
                      sx={{ pl: 4 }}
                      key={obj.id}
                      onClick={() => {
                        handleTableSelect(obj.id);
                      }}
                    >
                      <ListItemText primary={obj.name} />
                    </ListItemButton>
                  );
                })}
              </List>
            </Collapse>
          </List>
        </div>
        {activeTable ? (
          <div className="database-content">
            <div className="database-topbar">
              <div className="workspace-topbar-props">
                <div className="dashboard-chip">
                  <Chip
                    icon={<AddIcon />}
                    label="Add Item"
                    onClick={() => {
                      clearUser();
                      setDataDialog(true);
                    }}
                    className="dashboard-chip"
                    variant="outlined"
                  />
                </div>
              </div>

              <div className="workspace-topbar-actions">
                <div className="endpoint-chip">
                  <p className="endpoint-title">Actions:</p>
                  {/* <Tooltip title="Edit Endpoint">
                  <IconButton className="endpoint-button" onClick={() => {}}>
                    <EditIcon fontSize="14px" />
                  </IconButton>
                </Tooltip> */}
                  <Tooltip title="Delete Selection">
                    <IconButton
                      className="endpoint-action-delete"
                      onClick={() => {
                        let indexes = [];
                        for (let i = 0; i < selectedRow.length; i++) {
                          if (selectedRow[i] === true) {
                            indexes.push(data[i]);
                          }
                        }
                        handleDeleteEditData(indexes);
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              </div>
            </div>
            <div className="database-container">
              <DataTable
                data={data}
                dbTableFields={dbTableFields}
                setActiveData={handleSelectData}
                setEditData={setEditData}
                setDataDialog={setDataDialog}
                selectedRow={selectedRow}
                setSelectedRow={setSelectedRow}
              />
            </div>
          </div>
        ) : (
          <div className="database-container"></div>
        )}
      </div>
    </div>
  );
};
